/** LagKing gold (`colors.gold` in the app's theme tokens). The rollout board's
 *  default line and label color; the app asserts the two stay equal. */
export const LAGKING_GOLD = '#C8922A';
